const ICON = '/icon-192.png';
const live = new Map(); // message id -> { title, onOpen }

export const notificationsSupported = () => typeof window !== 'undefined' && 'Notification' in window;
export const canNotify = () => notificationsSupported() && Notification.permission === 'granted';

const spawn = (title, body, tag, onOpen) => {
  try {
    const n = new Notification(title, { body, tag, icon: ICON, silent: true });
    n.onclick = () => { window.focus(); onOpen?.(); n.close(); };
    return n;
  } catch {
    return null;
  }
};

export const showMessageNotification = ({ messageId, title, body, onOpen }) => {
  if (!canNotify()) return;
  spawn(title, body, `comms-${messageId}`, onOpen);
  live.set(messageId, { title, onOpen });
  setTimeout(() => live.delete(messageId), 60000);
};

// Replace a voice-message notification with its transcript once it arrives.
export const updateNotificationTranscript = (messageId, transcript) => {
  const entry = live.get(messageId);
  if (!entry || !transcript || !canNotify()) return;
  spawn(entry.title, `Voice message: ${transcript}`, `comms-${messageId}`, entry.onOpen);
};
